<template>
  <div>
    <b-modal
      id="modal-user-role"
      ref="modal_user_role"
      :title="newItem.name === '' ? 'Новая роль' : newItem.name"
      size="lg"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-card bg-variant="light">
            <b-row>
              <b-col cols="lg">
                <b-skeleton width="5%" height="22%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="36%" class="mb-3"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-skeleton width="12%" height="22%" class="pt-2 mb-2"/>
                <b-skeleton type="input" width="100%" height="44%"/>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <template #default>
          <b-card bg-variant="light">
            <b-form-group id="group-user-name" label="Роль">
              <b-form-input
                size="sm"
                placeholder="Введите название роли"
                v-model="newItem.name"
                :state="getFieldState('name')"
                @input="generateCode"
              />
            </b-form-group>
            <b-form-group id="group-user-permissions" label="Разрешения">
              <b-list-group bg-variant="light" class="text-small">
                <PermissionListItem v-for="(item, index) in treeData" :key="index" :item="item" :tree-data="treeData" :is-disabled="isDisabled"/>
              </b-list-group>
            </b-form-group>
          </b-card>
        </template>
      </b-skeleton-wrapper>

      <template>
        <div class="w-100 d-flex justify-content-end py-2">
          <b-button size="sm" variant="secondary" class="mr-2" @click="onCancel">
            Отменить
          </b-button>
          <b-button size="sm" variant="success" :disabled="loading || isDisabled" @click="onOk">
            <b-spinner v-if="loading" small/>
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import roles from "../../network/roles";
  import helpers from "../../utilites/helpers";
    import PermissionListItem from "../Users/PermissionListItem"

export default {
  components: { PermissionListItem },
  mixins: [
    roles,
    helpers
  ],
  name: "UserRole",
  data() {
    return {
      title: 'Права доступа',
      isBusy: false,
      isDisabled: false,
      loading: false,
      newItem: this.setNewItem(),
      permissions: [],
      treeData: []
    }
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        name: '',
        code: '',
        active: true,
        permissions: [],
      }
    },
    async showModal(userRoleId, isView) {
      this.isDisabled = isView;
      this.isBusy = true;
      this.loading = true;
      this.$refs.modal_user_role.show();

      if (userRoleId) {
        await this.getUserRole(userRoleId);
      } else {
        this.newItem = this.setNewItem();
      }

      await this.getPermissionsHandler();
    },
    onOk() {
      this.handleSubmit();
    },
    onCancel() {
      this.hideModal();
    },
    hideModal() {
      this.$refs.modal_user_role.hide();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getUserRole(userRoleId) {
      const result = await this.getUserRoleById(userRoleId);

      if (!result || !result.data) {
        this.showError("Не удалось получить данные.");
        return;
      }

      this.newItem = result.data;
    },
    async handleSubmit() {
      if (this.newItem.name === '') {
        this.showSubmitError("Укажите название роли.");
        return;
      }


      this.loading = true;
      this.updateUserPermissions();

      if (this.newItem.id === 0) {
        const roleStr = this.newItem.name.trim();

        if (roleStr) {
          this.newItem.code = this.transliterate(roleStr).toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
        }
      }

      const data = { ...this.newItem };
      const method = (data.id > 0) ? this.putUserRole : this.postUserRole;
      const result = await method(data);

      if (result && result.error) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.newItem = this.setNewItem();
        this.loading = false;
        this.hideModal();
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
      this.hideModal();

    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    generateCode() {
      const role = this.newItem.name.trim();
      const transliterated = this.transliterate(role);
      this.newItem.code = transliterated.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
    },
    // Permissions
    async getPermissionsHandler() {
      const result = await this.getPermissions();
      if (result.data != null) {
        this.permissions = result.data.items.map(function (item) {
          item._checked = this.newItem.permissions.some(perm => perm === item.code);
          return item;
        }.bind(this));
      } else {
        this.permissions = [];
      }

      this.treeData = this.arrayToTree(this.permissions);
      this.isBusy = false;
      this.loading = false;
    },
    updateUserPermissions() {
      const permArray = this.treeToArray(this.treeData);
      const filteredPerm = permArray.filter(perm => perm.checked || perm.indeterminate);
      this.newItem.permissions = filteredPerm.map(perm => perm.code);
    },
    arrayToTree(items, rootCode = null) {
      const lookup = {};
      items.forEach(item => {
        lookup[item.code] = {
          ...item,
          children: [],
          _selected: item._checked,
          _computedChecked: false,
          _computedIndeterminate: false
        };
      });

      const tree = [];
      items.forEach(item => {
        if (item.parent_code === rootCode) {
          tree.push(lookup[item.code]);
        } else {
          const parent = lookup[item.parent_code];
          if (parent) {
            parent.children.push(lookup[item.code]);
          }
        }
      });

      // Фаза 3: Рекурсивный расчет снизу вверх
      const computeNodeState = (node) => {
        if (!node.children || node.children.length === 0) {
          // Лист
          if (node._selected) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
          return { checked: node._computedChecked, indeterminate: node._computedIndeterminate };
        }

        // Обрабатываем детей
        let childCheckedCount = 0;
        let childIndeterminateCount = 0;

        node.children.forEach(child => {
          const state = computeNodeState(child);
          if (state.checked) childCheckedCount++;
          if (state.indeterminate) childIndeterminateCount++;
        });

        const allChildrenChecked = childCheckedCount === node.children.length;
        const someChildrenSelected = childCheckedCount > 0 || childIndeterminateCount > 0;

        // Правила определения состояния:
        // 1. Если узел в selectedSet, он должен быть либо checked, либо indeterminate
        // 2. Если все дети checked, узел должен быть checked
        // 3. Если некоторые дети selected (checked или indeterminate), узел должен быть indeterminate
        // 4. Иначе узел не выбран

        if (node._selected) {
          // Узел явно в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            // Если не все дети выбраны, но узел в selectedCodes,
            // значит он должен быть indeterminate
            node._computedChecked = false;
            node._computedIndeterminate = true;
          }
        } else {
          // Узел не в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else if (someChildrenSelected) {
            node._computedChecked = false;
            node._computedIndeterminate = true;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
        }

        return {
          checked: node._computedChecked,
          indeterminate: node._computedIndeterminate
        };
      };

      // Фаза 4: Применение вычисленных состояний
      const applyComputedStates = (node) => {
        node.checked = node._computedChecked;
        node.indeterminate = node._computedIndeterminate;

        delete node._selected;
        delete node._computedChecked;
        delete node._computedIndeterminate;

        if (node.children && node.children.length > 0) {
          node.children.forEach(child => applyComputedStates(child));
        }
      };

      // Выполняем расчеты
      tree.forEach(root => computeNodeState(root));
      tree.forEach(root => applyComputedStates(root));

      return tree;
    },
    // Функция преобразования дерева в массив
    treeToArray(nodes, parentCode = null) {
      const result = [];

      nodes.forEach(node => {
        result.push({
          code: node.code,
          name: node.name,
          parent_code: parentCode,
          checked: node.checked,
          indeterminate: node.indeterminate
        });

        if (node.children && node.children.length > 0) {
          result.push(...this.treeToArray(node.children, node.code));
        }
      });

      return result;
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Users/UserRole.vue